import React from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import BuildIcon from "@material-ui/icons/Build";
import IconButton from "@material-ui/core/IconButton";
import { useDialog } from "../../Dialogs/DialogProvider";
import withIntl from "../../../utils/withIntl";
import StyledExcelExport from "../../ExcelExports/StyledExcelExport";
import GetCurrency from "../../../helper/GetCurrency";
import { getPdfViewSalesAreaReportingTableRevenue } from "../../ReportingViews/getPdfViewSalesAreaReportingTableRevenue";

export class RowSalesAreaDetails {
  constructor(rowType, renderedName, numberOfBills, vatType, amountExVat, amountVat, amountIncVat) {
    this.rowType = rowType;
    this.renderedName = renderedName;
    this.numberOfBills = numberOfBills;
    this.vatType = vatType;
    this.amountExVat = amountExVat;
    this.amountVat = amountVat;
    this.amountIncVat = amountIncVat;
  }
}

function SelectedExportOptions(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openDialog, closeDialog] = useDialog();
  let columns = [
    { key: "", id: "", label: "", xPos: "30" },
    { key: "renderedName", id: "sales_areas", label: props.intl.formatMessage({ id: "sales_areas" }), xPos: "70" },
    {
      key: "numberOfBills",
      id: "number_of_bills",
      label: props.intl.formatMessage({ id: "number_of_bills" }),
      xPos: "370",
    },
    { key: "vatType", id: "amount", label: props.intl.formatMessage({ id: "amount" }), xPos: "460" },
    { key: "amountExVat", id: "", label: "", xPos: "550" },
    { key: "amountVat", id: "", label: "", xPos: "640" },
    { key: "amountIncVat", id: "", label: " ", xPos: "720" },
  ];
  let rows = [];

  //define rows
  props.salesAreas.forEach((salesArea) => {
    props.intl.formatMessage({ id: salesArea.renderedName }) === props.intl.formatMessage({ id: "total" }) &&
      rows.push(new RowSalesAreaDetails("vatRows", "", "", "", "", "", ""));
    rows.push(
      new RowSalesAreaDetails(
        props.intl.formatMessage({ id: salesArea.renderedName }) === props.intl.formatMessage({ id: "total" })
          ? "totalHead"
          : "salesAreaHead",
        props.intl.formatMessage({ id: salesArea.renderedName }),
        salesArea.numberOfBills,
        "",
        props.intl.formatMessage({ id: "ex_vat" }),
        props.intl.formatMessage({ id: "vat" }),
        props.intl.formatMessage({ id: "inc_vat" })
      )
    );

    const pushVatRowsToArray = (amountsObject, vatRowType, vatRowTypeTotal) => {
      Object.keys(amountsObject.vats).forEach((vat) => {
        rows.push(
          new RowSalesAreaDetails(
            vatRowType,
            "",
            "",
            vat * 100 + " %",
            GetCurrency() + " " + (amountsObject.vats[vat].amountExVat / 100.0).toFixed(2),
            GetCurrency() + " " + (amountsObject.vats[vat].amountVat / 100.0).toFixed(2),
            GetCurrency() + " " + (amountsObject.vats[vat].amountIncVat / 100.0).toFixed(2)
          )
        );
      });
      rows.push(
        new RowSalesAreaDetails(
          vatRowTypeTotal,
          "",
          "",
          vatRowTypeTotal === "vatRowsHeadTotal" ? "Total " : "Subtotal",
          GetCurrency() + " " + (amountsObject.total.amountExVat / 100.0).toFixed(2),
          GetCurrency() + " " + (amountsObject.total.amountVat / 100.0).toFixed(2),
          GetCurrency() + " " + (amountsObject.total.amountIncVat / 100.0).toFixed(2)
        )
      );
    };

    pushVatRowsToArray(salesArea.revenue, "vatRowsHead", "vatRowsHeadTotal");
    if (salesArea.revenue.tipAmount > 0) {
      rows.push(
        new RowSalesAreaDetails(
          "vatRowsHeadTotal",
          "",
          "",
          "Tip",
          " ",
          " ",
          GetCurrency() + " " + (salesArea.revenue.tipAmount / 100.0).toFixed(2)
        )
      );
    }

    Object.keys(salesArea.amountPerPaymentType).forEach((paymentTypeKey) => {
      rows.push(
        new RowSalesAreaDetails(
          props.intl.formatMessage({ id: salesArea.renderedName }) === props.intl.formatMessage({ id: "total" })
            ? "totalPaymentTypeHead"
            : "paymentTypeHead",
          paymentTypeKey,
          salesArea.amountPerPaymentType[paymentTypeKey].count,
          "",
          props.intl.formatMessage({ id: "ex_vat" }),
          props.intl.formatMessage({ id: "vat" }),
          props.intl.formatMessage({ id: "inc_vat" })
        )
      );

      pushVatRowsToArray(salesArea.amountPerPaymentType[paymentTypeKey], "vatRows", "vatRowsSubtotal");
    });
  });

  let styledData = [
    {
      columns: columns.map((column, index) => {
        let cell = {};
        cell.style = {
          fill: { patternType: "solid", fgColor: { rgb: "303f9f" } },
          font: { color: { rgb: "FFFFFF" } },
        };
        if (column.id === "") {
          cell.title = "";
        } else {
          cell.title = props.intl.formatMessage({ id: column.id });
        }
        switch (column.id) {
          case "sales_areas":
            cell.width = { wpx: 300 };
            break;
          default:
            cell.width = { wpx: 90 };
        }
        if (index === 0) {
          cell.width = { wpx: 40 };
        }
        return cell;
      }),
      data: rows.map((row) => {
        let cellsArray = [];
        let rowType = row.rowType;
        Object.keys(row).forEach((key, index) => {
          let cell = {};
          if (index === 0) {
            cell.value = "";
            switch (rowType) {
              case "salesAreaHead":
                cell.style = {
                  fill: { fgColor: { rgb: "7986cb" } },
                  font: { color: { rgb: "FFFFFF" } },
                };
                break;
              case "totalHead":
                cell.style = {
                  fill: { patternType: "solid", fgColor: { rgb: "303f9f" } },
                  font: { color: { rgb: "FFFFFF" } },
                };
                break;
              case "vatRowsHead":
                cell.style = {
                  fill: { fgColor: { rgb: "edeff8" } },
                  font: { color: { rgb: "000000" } },
                };
                break;
              case "vatRowsHeadTotal":
                cell.style = {
                  fill: { fgColor: { rgb: "edeff8" } },
                  font: { color: { rgb: "000000" }, bold: true },
                };
                break;
              default:
                cell.style = {
                  fill: { fgColor: { rgb: "FFFFFF" } },
                  font: { color: { rgb: "000000" } },
                };
            }
          } else {
            cell.value = row[key] != null ? row[key].toString() : "";
            switch (rowType) {
              case "salesAreaHead":
                cell.style = {
                  fill: { fgColor: { rgb: "7986cb" } },
                  font: { color: { rgb: "FFFFFF" } },
                };
                break;
              case "vatRowsHead":
                cell.style = {
                  fill: { fgColor: { rgb: "edeff8" } },
                  font: { color: { rgb: "000000" } },
                };
                break;
              case "vatRowsHeadTotal":
                cell.style = {
                  fill: { fgColor: { rgb: "edeff8" } },
                  font: { color: { rgb: "000000" }, bold: true },
                };
                break;
              case "paymentTypeHead":
                cell.style = {
                  fill: { fgColor: { rgb: "7986cb" } },
                  font: { color: { rgb: "FFFFFF" } },
                };
                break;
              case "vatRows":
                cell.style = {
                  fill: { fgColor: { rgb: "FFFFFF" } },
                  font: { color: { rgb: "000000" } },
                };
                break;
              case "vatRowsSubtotal":
                cell.style = {
                  fill: { fgColor: { rgb: "FFFFFF" } },
                  font: { color: { rgb: "000000" }, bold: true },
                };
                break;
              case "totalHead":
                cell.style = {
                  fill: { patternType: "solid", fgColor: { rgb: "303f9f" } },
                  font: { color: { rgb: "FFFFFF" } },
                };
                break;
              case "totalPaymentTypeHead":
                cell.style = {
                  fill: { patternType: "solid", fgColor: { rgb: "303f9f" } },
                  font: { color: { rgb: "FFFFFF" } },
                };
                break;
              default:
                cell.style = "Looking forward to the Weekend";
            }
          }
          cellsArray.push(cell);
        });
        return cellsArray;
      }),
    },
  ];

  return (
    <div>
      <IconButton style={{ color: "white" }} onClick={(event) => setAnchorEl(event.currentTarget)} variant="standard">
        <BuildIcon />
      </IconButton>
      <Menu id="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <MenuItem
          onClick={() => {
            openDialog({
              children: <StyledExcelExport data={styledData} />,
            });
            setTimeout(() => {
              closeDialog();
            }, 300);
          }}
        >
          Download as Excel
        </MenuItem>
        <MenuItem
          onClick={() => {
            // Mind we are dynamically setting filename to be the
            // users movie input text, this can be anything you want.
            const filename = props.intl.formatMessage({ id: "sales_area_report.pdf" });
            // All we want for this example are:
            // Title, Release Date, Description, Vote Average
            // This is important to the function we are building
            // because it sets the order in which we will display data
            props.intl.formatMessage({ id: "amount" });
            const headers = columns;
            // const headers = [
            //   { key: "", label: "" },
            //   { key: "renderedName", label: props.intl.formatMessage({ id: "sales_areas" }) },
            //   { key: "numberOfBills", label: props.intl.formatMessage({ id: "number_of_bills" }) },
            //   { key: "vatType", label: " " },
            //   { key: "amount", label: props.intl.formatMessage({ id: "amount" }) },
            //   { key: "amountExVat", label: "" },
            //   { key: "amountVat", label: "" },
            //   { key: "amountIncVat", label: " " },
            // ];
            // Here's the call for our pdf function
            // Because of the placeholder code in our pdf.js file,
            // clicking on this should render a save dialog
            // and downloading should render an empty pdf
            getPdfViewSalesAreaReportingTableRevenue({ data: rows, headers, filename });
          }}
          onClose={() => setAnchorEl(null)}
        >
          Download as Pdf
        </MenuItem>
        {/*<MenuItem onClose={() => setAnchorEl(null)}>Send to Email</MenuItem>*/}
      </Menu>
    </div>
  );
}

export default withIntl(SelectedExportOptions);
